import {
  FineModel,
  FineType,
  IDFines,
  InfringementModel,
  SearchBy,
} from "../../models/fineModels";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialFineState: FineModel = {
  type: null,
  currentStep: 1,
  infringement: null,
  account: null,
  infringementToken: null,
  searchBy: null,
  searchedID: null,
  idFines: null,
};

const fineSlice = createSlice({
  name: "fine",
  initialState: initialFineState,
  reducers: {
    setInfringementToken(state, action: PayloadAction<string | null>) {
      state.infringementToken = action.payload;
    },
    setAccount(state, action: PayloadAction<string | null>) {
      state.account = action.payload;
    },
    setFineType(state, action: PayloadAction<FineType | null>) {
      state.type = action.payload;
    },
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setInfringement(state, action: PayloadAction<InfringementModel | null>) {
      state.infringement = action.payload;
    },
    setSearchBy(state, action: PayloadAction<SearchBy | null>) {
      state.searchBy = action.payload;
    },
    setSearchedID(state, action: PayloadAction<string | null>) {
      state.searchedID = action.payload;
    },
    setIDFines(state, action: PayloadAction<IDFines[] | null>) {
      state.idFines = action.payload;
    },
  },
});
export default fineSlice;
